import React from 'react';
import './about.css';

const aboutUsData = {
  title: "ग्रामपंचायत भालेवाडी: प्रगतीचा संकल्प",
  intro: "भालेवाडी कारंजा (घा) तालुक्यात असलेले, संस्कृती आणि कृषीचे उत्तम मिश्रण असलेले गाव आहे. स्थानिक स्वराज्य संस्था म्हणून आम्ही, भालेवाडी एक आदर्श, आत्मनिर्भर आणि तंत्रज्ञान-स्नेही गाव बनवण्यासाठी कटिबद्ध आहोत.",

  visionTitle: "💡 आमची दृष्टी (Our Vision)",
  vision: [
    {
      icon: "🌐",
      title: "डिजिटल ग्राम",
      description: "ग्रामपंचायतीचे कामकाज पारदर्शक आणि डिजिटल माध्यमांतून चालवणे."
    },
    {
      icon: "🌿",
      title: "पर्यावरण पूरक विकास",
      description: "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे."
    },
    {
      icon: "🤝",
      title: "युवा आणि महिला सबलीकरण",
      description: "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे."
    }
  ],

  servicesTitle: "🏗 सेवा आणि सुविधा",
  services: [
    "पायाभूत सुविधा: उत्तम रस्ते, पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी आणि विविध शासकीय दाखले वेळेत देणे.",
    "शासकीय योजना: केंद्र आणि राज्य सरकारच्या योजनांचा लाभ लाभार्थ्यांपर्यंत पोहोचवणे."
  ],

  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",
    content: "ग्रामपंचायत म्हणजे केवळ कार्यालय नव्हे; ती गावकऱ्यांची संस्था आहे. ग्रामसभेला सर्वाधिक महत्त्व देऊन गावाचा विकास सामूहिक जबाबदारीने करण्याचा आमचा संकल्प आहे."
  },

  sarpanch: {
    name: "सौ यशोदा वामनराव पाटील",
    slogan: "👉 प्रत्येक नागरिकाच्या आवाजाला महत्त्व",
    message: "मी, सौ. यशोदा वामनराव पाटील, भालेवाडी नेतृत्वाची जबाबदारी स्वीकारताना ग्रामपंचायतीचे दरवाजे प्रत्येक नागरिकासाठी खुले ठेवण्याचा संकल्प केला आहे. माझ्या नेतृत्वाखालील कारभार जनता-केंद्रित व पारदर्शक आहे.",

    successTitle: "🎯 आमच्या कारभाराचे यशोगाथा",
    successStories: [
      {
        heading: "जबाबदार पाणी व्यवस्थापन",
        detail: "पाणी आडवा, पाणी जिरवा या तत्त्वावर काम करून जलसंधारणाचे काम पूर्ण केले."
      },
      {
        heading: "प्रदूषण नियंत्रण",
        detail: "गावातील सार्वजनिक ठिकाणी स्वच्छता आणि प्लास्टिक नियंत्रणावर भर दिला."
      },
      {
        heading: "सुलभ सेवा",
        detail: "ग्रामपंचायतीच्या सेवा नागरिकांना वेळेत उपलब्ध करून देण्याचा प्रयत्न केला."
      }
    ],

    youthTitle: "🌱 गावातील तरुणांसाठी गुंतवणूक",
    youthInvestment: [
      {
        heading: "डिजिटल कौशल्ये",
        detail: "तरुणांसाठी डिजिटल कौशल्य आणि संगणक प्रशिक्षणाला प्रोत्साहन."
      },
      {
        heading: "आरोग्य आणि खेळ",
        detail: "तरुणांच्या आरोग्यासाठी खेळाचे मैदान आणि व्यायाम सुविधा विकसित करण्याचा प्रयत्न."
      }
    ],

    closing: "भालेवाडी नागरिकांचे प्रेम आणि विश्वास हीच आमच्या कामाची खरी प्रेरणा आहे."
  },

 

  


  pdfs: [
    { title: "करांची मागणी नोंदवही", file: "/images/1.pdf" },
    { title: "ग्रामपंचायत नमूना ८", file: "/images/2.pdf" },
    { title: "कर आकारणी", file: "/images/3.pdf" },
    { title: "कर आकारणीचे रजिस्टर", file: "/images/4.pdf" }
  ]
};

const VisionItem = ({ icon, title, description }) => {
  return (
    <div className="vision-card">
      <div className="vision-icon">{icon}</div>
      <h4 className="vision-title">{title}</h4>
      <p className="vision-description">{description}</p>
    </div>
  );
};

const AboutUs = () => {
  const { sarpanch } = aboutUsData;

  return (
    <div className="page about-us-page">

      <header className="page-header">
        <h1>{aboutUsData.title}</h1>
        <p className="page-intro">{aboutUsData.intro}</p>
      </header>

      <main className="page-content-grid">

        <section className="section vision-section">
          <h2>{aboutUsData.visionTitle}</h2>

          <div className="vision-cards-container">
            {aboutUsData.vision.map((item, index) => (
              <VisionItem
                key={index}
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </section>

        <section className="section services-section">
          <h2>{aboutUsData.servicesTitle}</h2>

          <ul className="service-list">
            {aboutUsData.services.map((service, index) => (
              <li key={index} className="service-item">
                {service}
              </li>
            ))}
          </ul>
        </section>

        <section className="section participation-section bg-light">
          <h3>{aboutUsData.participation.heading}</h3>
          <p>{aboutUsData.participation.content}</p>
        </section>

        <section className="section sarpanch-section">
          <div className="sarpanch-card">
            <h2 className="sarpanch-name">
              सन्माननीय प्रशासक : {sarpanch.name}
            </h2>

            <p className="sarpanch-slogan">{sarpanch.slogan}</p>
            <p className="sarpanch-message">{sarpanch.message}</p>
          </div>
        </section>

        

        <section className="section success-stories-section">
          <h3>{sarpanch.successTitle}</h3>

          <div className="story-list">
            {sarpanch.successStories.map((story, index) => (
              <div key={index} className="story-item">
                <h4>{story.heading}</h4>
                <p>{story.detail}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section youth-investment-section bg-light">
          <h3>{sarpanch.youthTitle}</h3>

          <div className="investment-list">
            {sarpanch.youthInvestment.map((item, index) => (
              <div key={index} className="investment-item">
                <h4>{item.heading}</h4>
                <p>{item.detail}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="pdf-section">
          <h2>📄 महत्त्वाचे दस्तऐवज</h2>

          <div className="pdf-list">
            {aboutUsData.pdfs.map((pdf, index) => (
              <div key={index} className="pdf-item">
                <div className="pdf-icon">📄</div>

                <p className="pdf-title">{pdf.title}</p>

                <div className="pdf-buttons">
                  <a href={pdf.file} target="_blank" rel="noopener noreferrer">
                    👁 View
                  </a>

                  <a href={pdf.file} download>
                    ⬇ Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

      </main>

      <footer className="page-footer">
        <p className="closing-note">
          *** {sarpanch.closing} ***
        </p>
      </footer>

    </div>
  );
};

export default AboutUs;